import { PermissionTableRowType } from '../../../../../../types/common/PermissionType';
import { PERMISSION_ACTIONS, PERMISSION_SUBJECTS } from '../../../../../../constants/service/common/userPermissions';
/*
생성/등록/추가 : create
삭제/제거 : delete
편집/수정 : update
상세페이지/보기 : read
리스트/보기 : readList
엑셀다운로드 : downloadExcel
*/
export const SYSTEM_MENU: PermissionTableRowType = {
  name: '시스템',
  key: 'SYSTEM_MANAGE',
  subRows: [
    {
      // 바꾸면 그 환경의 서버 전체 동작이 바뀐다(출시 · 긴급 OFF) — 최상위 관리자도 이 권한을 따로 켜야 메뉴가 보인다
      name: '서버 피처 플래그',
      key: PERMISSION_SUBJECTS.FEATURE_FLAG,
      permissions: [PERMISSION_ACTIONS.READ, PERMISSION_ACTIONS.UPDATE],
      subRows: [
        {
          name: '플래그 · 이력 조회',
          key: PERMISSION_SUBJECTS.FEATURE_FLAG,
          permissions: [PERMISSION_ACTIONS.READ],
        },
        {
          name: '켜기 · 끄기',
          key: PERMISSION_SUBJECTS.FEATURE_FLAG,
          permissions: [PERMISSION_ACTIONS.UPDATE],
        },
      ],
    },
  ],
};
